import { ChangeDetectionStrategy, Component, input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { NODE_EDIT_TAB_COMPONENT, NodeEditTab, SelectedNodeForEdit } from 'src/app/shared/flow-chart/flow-chart.model';
import { ManualTriggerNodeData } from '../../../node-edit.type';

@Component({
  selector: 'edit-trigger-manually',
  imports: [
    ReactiveFormsModule,
    TranslatePipe
  ],
  templateUrl: './edit-trigger-manually.component.html',
  styleUrl: './edit-trigger-manually.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NODE_EDIT_TAB_COMPONENT,
      useExisting: EditTriggerManuallyComponent,
    },
  ],
})
export class EditTriggerManuallyComponent implements OnInit, NodeEditTab{
  public selectedNodeForEdit = input<SelectedNodeForEdit<ManualTriggerNodeData>>();
  public disableForm = input<boolean>(false);

  public form!: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private translateService: TranslateService,
  ) { }

  public ngOnInit(): void {
    this.form = this.fb.group({
      name: [
        this.selectedNodeForEdit()?.data?.name ??
        this.translateService.instant('FLOW_CHART.NODES.MANUAL_TRIGGER.NAME'),
        [Validators.required],
      ],
    });
  }
}
